// extracted by mini-css-extract-plugin
export default {"component":"Error_component__7gjjf","spin":"Error_spin__2XmpV"};